import NewInvoiceScreen from './NewInvoiceScreen';

export default NewInvoiceScreen;
